/*
 * Copyright 2026 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/kmp-project-template/blob/main/LICENSE
 */
package kpt.core.database.di

import kpt.core.database.AppDatabase
import org.koin.core.module.Module
import org.koin.dsl.module

/**
 * GENERATED — one Koin binding per DAO, framework and fork alike. DO NOT HAND-EDIT.
 *
 * To add a DAO: annotate it `@DbDao`. That is the whole wiring step — the accessor on
 * `AppDatabase` and this binding both come from that one annotation.
 *
 * Pulled in by `DatabaseModule` via `includes(GeneratedDaoBindings)`.
 */
val GeneratedDaoBindings: Module = module {
    single { get<AppDatabase>().bookkeeperDao }
    single { get<AppDatabase>().fetchedAtDao }
    single { get<AppDatabase>().draftDao }
    single { get<AppDatabase>().conflictDao }
    single { get<AppDatabase>().alertDao }
    single { get<AppDatabase>().billReminderDao }
    single { get<AppDatabase>().cloudTodoDao }
    single { get<AppDatabase>().coinDetailDao }
    single { get<AppDatabase>().coinMarketDao }
    single { get<AppDatabase>().exchangeRatesDao }
    single { get<AppDatabase>().interestRateSeriesDao }
    single { get<AppDatabase>().loanDao }
    single { get<AppDatabase>().rateHistoryDao }
    single { get<AppDatabase>().watchlistDao }
}
